<div class="autocomplete-container"
  ntsObserveVisibility
  (visibleChange)="onVisible($event)"
  #popperInfo="popper"
  (mouseenter)="mouseEnter($event)"
  (mouseleave)="mouseLeave($event)"
  [popper]="value?.description ?? ''"
  [popperDisabled]="!value?.description || value?.description?.length == 0 || (showErrorTooltip && !isDisabled && computedErrors?.length > 0)"
  [popperTrigger]="ngxPopperjsTriggers.hover"
  popperApplyClass="info"
  [popperPlacement]="ngxPopperjsPlacements.TOP"
  [popperPreventOverflow]="false"
  [popperHideOnScroll]="true"
  popperAppendTo="body"
  [popperDelay]="1500"
  [ngClass]="uniqueId"
  [class.is-locked]="isLocked && !isDisabled"
  [class.is-searchable]="isSearchable"
  [class.zoom-disabled]="isDisabled">
  <ng-select
    #popperError="popper"
    [popper]="tooltipErrTemplate"
    [popperDisabled]="!(showErrorTooltip && !isDisabled && computedErrors?.length > 0)"
    [popperTrigger]="ngxPopperjsTriggers.hover"
    popperApplyClass="error"
    [popperPlacement]="ngxPopperjsPlacements.TOP"
    [popperPreventOverflow]="false"
    [openOnEnter]="false"
    [typeToSearchText]="typeToSearchText"
    [popperHideOnScroll]="true"
    [clearOnBackspace]="false"
    [clearable]="isClearable$ | async"
    popperAppendTo="body"
    (open)="onDropdownOpen()"
    (close)="onDropdownClose()"
    (blur)="blur()"
    (clear)="clear()"
    (focus)="focus($event)"
    (change)="onSelectedItem($event)"
    [(ngModel)]="value"
    [selectOnTab]="false"
    [appendTo]="appendToCssSelector$ | async"
    [searchable]="isSearchable"
    [readonly]="isDisabled || isLocked"
    [loading]="isLoading$ | async"
    [multiple]="false"
    [keyDownFn]="keyDownFn.bind(this)"
    [trackByFn]="trackByFn"
    [typeahead]="isSearchable ? itemInput$: undefined"
    [class.search-hidden]="searchCommand == null || !(searchCommand.isVisible$ | async) || !isSearchable"
    [class.has-error]="showErrorBorder && computedErrors?.length > 0"
    [class.is-loading]="isLoading$ | async"
    [class.has-clear]="inputRef?.showClear() && (isClearable$ | async)"
    [class.deactivated]="isSelectedItemDeactivated()"
    [class.has-input-value]="(inputValue$ | async)?.length > 0"
    [class.is-searchable]="isSearchable"
    [items]="items$ | async"
    class="external-box"
    notFoundText="{{'NessunElementoTrovato' | NTSTranslate}}"
    clearAllText="{{'Pulisci' | NTSTranslate}}"
    loadingText="{{'CaricamentoInProgress' | NTSTranslate}}"
    [dropdownPosition]="dropdownPosition"
    [placeholder]="computedPlaceholder"
    bindLabel="description">
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <span [attr.title]="item.description" class="ng-option-label" [ngOptionHighlight]="search"
      [class.deactivated]="isItemDeactivated(item)">{{item.description}}</span>
    </ng-template>
    <ng-template ng-footer-tmp>
      <div class="actions-container">
        <div class="left-actions">
          @if (copyCommand && (copyCommand.isVisible$ | async)) {
            <nts-text-button
              [title]="copyCommand.description"
              [additionalClasses]="[$safeNavigationMigration(inputRef?.dropdownId)]"
              [isDisabled]="!(copyCommand.canExecute$ | async)"
              [icon]="copyCommand.iconClass"
            (onClicked)="copyCommand.execute(externalBoxCommandUtility)"></nts-text-button>
          }
          @if (viewItemCommand && (viewItemCommand.isVisible$ | async)) {
            <nts-text-button
              [title]="viewItemCommand.description"
              [additionalClasses]="[$safeNavigationMigration(inputRef?.dropdownId)]"
              [isDisabled]="!(viewItemCommand.canExecute$ | async)"
              [icon]="viewItemCommand.iconClass"
            (onClicked)="inputRef.close(); viewItemCommand.execute(externalBoxCommandUtility)"></nts-text-button>
          }
        </div>
        <div class="right-actions">
          @if (addItemCommand && (addItemCommand.isVisible$ | async)) {
            <nts-text-button
              [title]="addItemCommand.description"
              [label]="addItemCommand.displayName"
              [additionalClasses]="[$safeNavigationMigration(inputRef?.dropdownId)]"
              [isDisabled]="!(addItemCommand.canExecute$ | async)"
              [icon]="addItemCommand.iconClass"
            (onClicked)="inputRef.close(); addItemCommand.execute(externalBoxCommandUtility)"></nts-text-button>
          }
        </div>
      </div>
    </ng-template>
  </ng-select>
  @if (!isDisabled && !isLocked && isSearchable && searchCommand && ($safeNavigationMigration(searchCommand?.isVisible$) | async)) {
    <div class="autocomplete-actions"
      >
      @if (searchCommand && (searchCommand.isVisible$ | async)) {
        <nts-text-button
          [title]="searchCommand.description"
          (onClicked)="searchCommand.execute()"
          [isDisabled]="!(searchCommand.canExecute$ | async)"
          [tabIndex]="-1"
        [icon]="searchCommand.iconClass"></nts-text-button>
      }
    </div>
  }
</div>

<popper-content #tooltipErrTemplate>
  @for (item of computedErrors; track item) {
    {{ item }}
  }
</popper-content>